// extracted by mini-css-extract-plugin
export default {"wrapper":"ZGzu491","actions":"tdRmAGV"};